import React, { Component } from 'react'

import logoImg from './logo.png'
import roseImg from './rose.jpg'
import whiteImg from './white.jpg'
import oakImg from './oak.jpg'

import './landing.css'

class Landing extends Component{

  render() {
    return(
      <div className="Landing-container-new">
        <div className="Landing-header-new">
          <img
            src={logoImg}
            alt="Escapat logga"
            className="w-max-100"
          />
          <h1>Vinabonnemang</h1>
        </div>
        <div className="Landing-grid">
          <div className="row reverse">
            <div className="block">
              <div>
                <h3>Alltid fraktfritt</h3>
                <p>
                  Från gården Escapat direkt hem till dörren helt fraktfritt!
                </p>
              </div>
            </div>
            <div
              className="block"
              style={{backgroundImage: `url(${roseImg})`}} >
            </div>
          </div>
          <div className="row">
            <div
              className="block"
              style={{backgroundImage: `url(${whiteImg})`}} >
            </div>
            <div className="block">
              <div>
                <h3>Skräddarsy som du vill</h3>
                <p>
                  Välj fritt bland lådor och vilka månader om året du vill ha leverans.
                  Efter du har beställt kommer du få ett email med inloggningsuppgifter till din abonnemangssida.
                </p>
              </div>
            </div>
          </div>
          <div className="row reverse">
            <div className="block">
              <div>
                <h3>Ingen bindningstid</h3>
                <p>
                  Vi har ingen bindningstid, du kan avsluta när du vill.
                </p>
              </div>
            </div>
            <div
              className="block"
              style={{backgroundImage: `url(${oakImg})`}} >
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landing/Landing.jsx